import React from "react";
import ReactDOM from "react-dom/client"; // ✅ Required for React 18+
import App from "./App";
import reportWebVitals from "./reportWebVitals";

const root = ReactDOM.createRoot(document.getElementById("root")); // ✅ Correct for React 18 and 19
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

reportWebVitals();
